// extracted by mini-css-extract-plugin
export default {"root":"X5xafPIOiu","text":"ZAvvJl9_sc"};